import { render, staticRenderFns } from "./vessel-nomination-form.vue?vue&type=template&id=3dfbb69b&scoped=true&"
import script from "./vessel-nomination-form.vue?vue&type=script&lang=js&"
export * from "./vessel-nomination-form.vue?vue&type=script&lang=js&"
import style0 from "./vessel-nomination-form.vue?vue&type=style&index=0&id=3dfbb69b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfbb69b",
  null
  
)

export default component.exports